import {
  isCatalogType,
  toTypeId,
  type ExclusionAreaProperties,
  type ExclusionAreaType,
} from './exclusionAreaTypeResolution'

/**
 * While the catalog is still loading there is nothing to check the id against,
 * so any assigned type passes rather than blocking the save on a pending request.
 */
export const hasValidExclusionAreaType = (
  properties: ExclusionAreaProperties | undefined,
  exclusionAreaTypes?: ExclusionAreaType[],
) => {
  if (!exclusionAreaTypes) return toTypeId(properties?.exclusionAreaTypeId) !== null
  return isCatalogType(toTypeId(properties?.exclusionAreaTypeId), exclusionAreaTypes)
}
